import { apiGet, GetManageConsulteesResponse } from 'api';
import { GetManageConsulteesRequest } from '../../types';

export const getManageConsultees = (
  request: GetManageConsulteesRequest
): Promise<GetManageConsulteesResponse> =>
  apiGet<GetManageConsulteesResponse, GetManageConsulteesRequest>('admin/consultees', request);
